import type { AxiosInstance } from 'axios';
import { Service } from '../types/service';
import { transformServices } from '../transforms/service';
import { ServiceModel } from '@/models/service';

class ServiceService {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getServicesWithActiveProducts(propertyId: string): Promise<ServiceModel[]> {

    const response = await this.client.get<Service[]>('/services', {
      params: {
        $query: {
          propertyId,
          $expand: {
            products: {}
          }
        }
      }
    });

    return transformServices(response.data.data);
  }
}

export { ServiceService };
